<form #form="ngForm" class="inputs-group" (ngSubmit)="onSaveMenuItem()" rte="iw">
    <div class="inputs-group-row" rte="iH">
        <label for="routerLink" class="inputs-group-row-name" rte="iI">Router link:</label>
        <div class="inputs-group-row-value" rte="iJ">
            <p-dropdown [(ngModel)]="menuItem.routerLink"
                        [options]="routes"
                        optionLabel="title"
                        optionValue="path"
                        [showClear]="true"
                        [filter]="true"
                        filterBy="title"
                        id="routerLink"
                        name="routerLink"
                        placeholder="Choose a router link"
                        [disabled]="menuItem.customHandler"
                        (onChange)="onItemRouteChange($event)"
                        rte="iK">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="menuItem.routerLink" rte="1bt">
                        <div rte="1bu">{{titleByPath(menuItem.routerLink)}}</div>
                        <div class="route-selector-path" rte="1bv">{{menuItem.routerLink}}</div>
                    </div>
                </ng-template>
                <ng-template let-route pTemplate="item">
                    <div rte="1bw">
                        <div rte="1bx">{{route.title}}</div>
                        <div class="route-selector-path" rte="1by">{{route.path}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
    <div class="inputs-group-row" rte="iL">
        <div class="inputs-group-row-name" rte="iM">
            <label for="customHandler" rte="iN">Custom handler:</label>
        </div>
        <div class="inputs-group-row-value" rte="iO">
            <p-dropdown [(ngModel)]="menuItem.customHandler"
                        [options]="customHandlersOptions"
                        [showClear]="true"
                        id="customHandler"
                        name="customHandler"
                        placeholder="Select pre-defined handler"
                        [disabled]="menuItem.routerLink" rte="iP">
            </p-dropdown>
        </div>
    </div>
    <div class="inputs-group-row" rte="ix">
        <label for="name" class="inputs-group-row-name asterisk-mark" rte="iy">Name:</label>
        <div class="inputs-group-row-value" rte="iz">
            <input pInputText [(ngModel)]="menuItem.label" id="name" name="label" required notEmpty rte="iA" />
        </div>
    </div>
    <div class="inputs-group-row" rte="iQ">
        <div  class="inputs-group-row-name" >
            <div class="flex align-items-center">
                <label rte="iR" >Icon:</label>
                <bb-tooltip message="If both Material and ORB icons are selected, ORB icon takes precedence"></bb-tooltip>
            </div>
        </div>
        <div class="inputs-group-row-value" rte="iS">
            <p-selectButton [options]="iconSourceOptions"
                            [(ngModel)]="iconSourceSelected"
                            [ngModelOptions]="{standalone:true}"></p-selectButton>
            <p [style.margin]="'2px'"></p>
            <bb-icon-dropdown *ngIf="iconSourceSelected === iconSources.Material"
                              [iconSource]="iconSources.Material"
                              [(iconModel)]="menuItem.icon"
                              rte="iT"></bb-icon-dropdown>
            <bb-icon-dropdown *ngIf="iconSourceSelected === iconSources.MiPro"
                              [iconSource]="iconSources.MiPro"
                              [(iconModel)]="menuItem.miproIcon"></bb-icon-dropdown>
        </div>
    </div>
    <div class="inputs-group-row" rte="iU">
        <div class="inputs-group-row-name" rte="iV">
            <div class="flex align-items-center">
                <label for="hidden" rte="iW">Hidden:</label>
                <bb-tooltip message="This option switched on doesn't change access rules for a page linked to a menu item but just hides the item. After you check the option the page will remain accessible." rte="iX">
                </bb-tooltip>
            </div>
        </div>
        <div class="inputs-group-row-value" rte="iY">
            <p-checkbox [(ngModel)]="menuItem.hidden" [binary]="true" id="hidden" name="hidden" rte="iZ"></p-checkbox>
        </div>
    </div>

    <div class="buttons-panel flex align-items-center justify-content-end" rte="j0">
        <div *ngIf="enableSavingItemToDatabase" class="flex align-items-center" [style.padding]="'0.25rem 0'">
            <p-checkbox
                name="saveToDatabase"
                [(ngModel)]="saveItemToDatabase"
                [binary]="true"
                label="Save to database"></p-checkbox>
            <i class="material-icons" (click)="saveToDabaseMeaning.toggle($event)" [style]="{ cursor: 'help', color: '#b1b1b1' }">
                info
            </i>
        </div>

        <button pButton *ngIf="isNewItem" type="button" label="Cancel" class="p-button-secondary" (click)="onCancelNewItem()" rte="1bJ">
            <i class="material-icons" rte="1bK">clear</i>
        </button>

        <button pButton type="submit" label="Save" [disabled]="form.invalid" rte="j1">
            <i class="material-icons" rte="1bL">check</i>
        </button>
    </div>
</form>

<p-overlayPanel #saveToDabaseMeaning styleClass="save-to-database-overlaypanel" appendTo="body">
    <p-messages severity="info">
        <ng-template pTemplate>
            <div class="flex align-items-start">
                <i class="pi pi-database mr-2" [style.font-size.rem]="2.2"></i>
                <div>
                    <p>The LHS menu is loaded from a static file in the server, meaning that after each release it will be replaced.</p>
                    <p>
                        If this is a dynamic LHS menu item, e.g. a published Dashboard, you can check this option so we can do a little
                        extra work to keep it across releases.
                    </p>

                    <p [style.margin-bottom]="0"><b>Note:</b></p>
                    <ul [style.margin-top]="0">
                        <li>
                            This functionality is meant for leaf LHS menu items only ― that is, without children. This means that if later a
                            child is added to this item, it will not be recovered after a release.
                        </li>
                        <li>
                            We do not search for duplicate items during creation, if you're not sure to check this option, please check the
                            list of LHS side items already saved.
                        </li>
                        <li>
                            If you delete a LHS menu item that was saved to the database you need to manually delete it from the saved LHS
                            menu items.
                        </li>
                    </ul>
                </div>
            </div>
        </ng-template>
    </p-messages>
</p-overlayPanel>
